export default __webpack_public_path__ + "static/media/sid_light.443addb8.png";